import en from './en.json'
import et from './et.json'

export const sharedTranslations = {
  en,
  et,
}
